import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
export const getFeatures = ({
  highlightedProducts,
  productLine
}) => {
  return noAuthHttp.get(`${getFullUrl('app-api', {})}/feature/store/v1/features/by-api-names`, {
    query: {
      productApiNames: highlightedProducts
    }
  }).then(res => {
    return {
      [productLine]: res
    };
  }).catch(error => {
    console.log('error ~~~~>', error);
  });
};